var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "#45657B",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3344_476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81384 0 0 3.81384 0 8.5C0 13.1862 3.81384 17 8.5 17C13.1862 17 17 13.1862 17 8.5C17 3.81384 13.1862 0 8.5 0ZM8.5 16.3799C4.15491 16.3799 0.620136 12.8451 0.620136 8.5C0.620136 4.15491 4.15491 0.620136 8.5 0.620136C12.8451 0.620136 16.3799 4.15491 16.3799 8.5C16.3799 12.8451 12.8451 16.3799 8.5 16.3799Z",
    fill: "#45657B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 4.28711C8.1113 4.28711 7.79297 4.5455 7.79297 4.95892C7.79297 5.37235 8.1113 5.63074 8.49992 5.63074C8.88854 5.63074 9.20688 5.37235 9.20688 4.95892C9.20688 4.5455 8.88854 4.28711 8.49992 4.28711Z",
    fill: "#45657B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00654 6.7041H7.99365V12.7132H9.00654V6.7041Z",
    fill: "#45657B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3344_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#45657B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.20c8f26379c577ac3961de0f0820f439.svg";
export { ForwardRef as ReactComponent };